export enum RoomStatusEnum {
  active = 'active',
  inactive = 'inactive',
}
